export default "__VITE_ASSET__eaf25816__"